export class AbandonedCartRequest {
  studentId: string;
  accountId: string;
  programLevelId: string;
  courseId: string;
}
